import { DateTimeProvider } from 'angular-oauth2-oidc';
import { Injectable } from '@angular/core';
import { TIME_OFFSET } from '../../shared/constants';

@Injectable()
export class ServerDatetimeProvider extends DateTimeProvider {
    new(): Date {
        return new Date(this.getAdjustedTime());
    }

    now(): number {
        return this.getAdjustedTime();
    }

    private getAdjustedTime(): number {
        const offset = this.getTimeOffset();
        return Date.now() + offset;
    }

    private getTimeOffset(): number {
        const offsetString = localStorage.getItem(TIME_OFFSET);
        return offsetString ? parseInt(offsetString, 10) : 0;
    }
}
